module.exports = __webpack_public_path__ + "img/dian_9b5197295.png";